import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import sedeApi from "../api/sedeApi";
import empresaApi from "../api/empresaApi";
import { useLocation } from "./useLocation";

const emptyForm = {
    id: "", id_empresa: "", nombreSede: "", codigoSede: "",
    direccion: "", id_muni: "", telefono: "", estado: 1, ciudad: ""
};

export const useSede = () => {
    const [sedes, setSedes] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState(null);
    const [form, setForm] = useState(emptyForm);

    const { departments: departamentos, towns: municipios } = useLocation(form.id_dept, true);

    const loadData = async () => {
        try {
            const [sedesRs, empresasRs] = await Promise.all([
                sedeApi.getAll(),
                empresaApi.getAll()
            ]);
            setSedes(sedesRs.data || []);
            setEmpresas(empresasRs.data || []);
        } catch (error) {
            toast.error("Error cargando daos de sedes");
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleSelect = (s) => {
        setSelected(s.id);
        setForm({ ...emptyForm, ...s });
    };

    const handleNew = () => {
        setSelected(null);
        setForm(emptyForm);
    };

    const saveSede = async () => {
        if (!form.nombreSede || !form.id_empresa || !form.codigoSede) {
            toast.warn("Nombre de sede, empresa y código de habilitación son obligatorios");
            return;
        }
        if (!/^\d+$/.test(form.codigoSede)) {
            toast.warn("El código de habilitación debe ser un valor numérico");
            return;
        }
        if (form.telefono && !/^\d{10}$/.test(form.telefono)) {
            toast.warn("El teléfono debe tener exactamente 10 dígitos numéricos");
            return;
        }

        // Si seleccionó municipio, guardamos el nombre en "ciudad" para backend
        let dataToSave = { ...form };
        if (form.id_muni && municipios.length > 0) {
            const muni = municipios.find(m => String(m.codigo) === String(form.id_muni));
            if (muni) dataToSave.ciudad = muni.descripcion;
        }

        try {
            const rs = await sedeApi.save(dataToSave);
            if (rs.success) {
                toast.success("Guardado con éxito");
                loadData();
                handleNew();
            } else {
                toast.error(rs.message || "Error al guardar");
            }
        } catch (error) {
            toast.error("Error al guardar sede");
        }
    };

    return {
        sedes,
        empresas,
        search,
        setSearch,
        selected,
        form,
        setForm,
        departamentos,
        municipios,
        handleSelect,
        handleNew,
        saveSede,
    };
};
